(function () {
    var controller = {
        $body: $('body'),
        active: null,
        escape: 27,
        enabled: false,
        $activeComponent: null,
        $container: null,
        $target: null,

        init: function () {
            controller.control();
            controller.extra();
            controller.check();
            controller.extra();
        },
        control: function () {
            $(document).on('keydown', function (e) {
                // hide / close when esc key is pressed
                if ((e.keyCode || e.which) === controller.escape) {
                    controller.check(e);
                }
            });
        },
        check: function (e) {
            // check if there is open / active component
            controller.active = controller.$body.attr('data-active');
            if (controller.active != null) {
                controller.disable(e);
            }
        },
        disable: function (e) {
            // hide / close active component
            // return focus to controller if component was closed by check()
            if (typeof UX[controller.active].$controller !== 'undefined') {
                UX[controller.active].$controller.focus();
            }
            UX[controller.active].on.hide(e);
        },
        extra: function () {
            controller.$body.on('click focusout', function (e) {
                // hide / close opened components when click out side it
                // @todo: this can be still improved for nested compoentns, when click is outside of all of them, close all, not only current one - but it is a feature
                // if key was pressed, than we need to operate with related target, not original target
                if (e.type === 'focusout' && e.target !== e.relatedTarget) {
                    if (e.relatedTarget !== null) {
                        e.target = e.relatedTarget;
                    }
                }
                controller.active = controller.$body.attr('data-active');
                controller.$activeComponent =
                    typeof UX[controller.active] !== 'undefined' ? UX[controller.active] : 'undefined';

                if (
                    typeof controller.$activeComponent !== 'undefined' &&
                    typeof controller.$activeComponent.$section !== 'undefined' &&
                    typeof controller.$activeComponent.$controller !== 'undefined'
                ) {
                    controller.$container = controller.$activeComponent.$section;
                    controller.$target = controller.$activeComponent.$controller;
                    controller.checkToHide(e);
                }
            });
        },
        checkToHide: function (e) {
            if (
                !controller.$container.is(e.target) && // if the target of the click isn't the container...
                controller.$container.has(e.target).length === 0 &&
                !controller.$target.is(e.target) && // if the target of the click isn't the controller...
                controller.$target.has(e.target).length === 0 && // ... nor a descendant of the controller
                !$(e.target).closest('.ui-autocomplete').length
            ) {
                controller.$activeComponent.on.hide(e);
            }
        },
    };

    UX.controller = controller; // add to global namespace
})();
